var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "nanogl-pbr/glsl/includes/glsl-compat.frag" )() )+
'\n\n#pragma SLOT pf\n\n\n\n// MATH\n// =========\n#define saturate(x) clamp( x, 0.0, 1.0 )\n#define sdot( a, b ) saturate( dot(a,b) )\n\n// Ground texture & scroll\nuniform float uStop;\nuniform float uScroll;\n\n//                MAIN\n// ===================\n\nvoid main( void ){\n  vec2 uvs = uBaseColor0_texCoord();\n  vec4 _baseColor = vec4(0., 0., 0., 1.);\n\n  #pragma SLOT f\n  \n  FragColor.xyz = _baseColor.rgb;\n  FragColor.a = _baseColor.a;\n\n  #pragma SLOT postf_linear \n  #pragma SLOT postf\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;